import { V2 } from '@eventr/common'
import { DisclosureGroup } from '../common/DisclosureGroup'
import { useBoundStore } from '../state/bound.store'
import { selectorSplitData } from '../state/itineraryState/currentItin.slice'
import { TodoDisclosureGroup } from './componentCards/todoComponents/todoDisclosureGroup'
import { RendererLocator } from './renderers/rendererLocator'
import { ScreenTypeProvider } from './state/screenTypeProvider'
import { publicColour } from './v2Utils'

interface IRendererSplitterTeamsProps {
    v2Data: V2[]
    openDisclosure?: boolean
    stickyHeaders?: boolean
}

export function RendererSplitterTeams({
    v2Data,
    openDisclosure,
    stickyHeaders,
}: IRendererSplitterTeamsProps) {
    const { splitSections, categorized, todos } = useBoundStore((state) =>
        selectorSplitData(state, v2Data)
    )

    return (
        <ScreenTypeProvider
            screenType="team"
            openDisclosure={openDisclosure}
            stickyHeaders={stickyHeaders}
        >
            <TodoDisclosureGroup
                open={openDisclosure ?? false}
                todosList={todos}
            />
            {categorized?.map((d, index) => {
                if (
                    d.sectionDisplayNameTeams &&
                    d.data &&
                    d.data[Object.keys(d.data)[0]]?.length !== 0
                )
                    return (
                        <RendererLocator
                            id={index.toString()}
                            key={index}
                            data={d}
                            screenType="team"
                        />
                    )
                return <div key={index} />
            })}
            {splitSections?.map((pub, i) => {
                return (
                    <DisclosureGroup
                        key={'i' + i}
                        decourColour={publicColour}
                        childrenHandlePadding
                        stickyHeader={false}
                        borderPosition="underTitle"
                        title={pub.name.toUpperCase()}
                        isOpen={true}
                        content={pub.data?.map((d, j) => (
                            <RendererLocator
                                data={d}
                                screenType={'team'}
                                isPublic={true}
                                key={'v2Section' + j + i}
                            />
                        ))}
                    />
                )
            })}
        </ScreenTypeProvider>
    )
}
